<script setup lang="ts">
import { computed } from "vue";

import type { ReportGroupDto } from "@/dto";
import ProjectDetailViewExperimentsSearchGroupSelectorItem from "@/views/projects/ProjectDetailViewExperimentsSearchGroupSelectorItem.vue";

const { groups } = defineProps<{
  title: string;
  groups: ReportGroupDto[];
}>();

const emit = defineEmits<{ selected: [dataset: string, estimator?: string] }>();

const groupVM = computed(() => {
  // @TODO: change backend endpoint to reflect this new structure
  return groups.map((group) => {
    return {
      dataset: group.dataset,
      mlTasks: group.reports[0]?.ml_task ?? "",
      estimators: [...new Set(group.reports.map((report) => report.estimator_class_name))],
    };
  });
});

function onGroupSelected(dataset: string, estimator?: string) {
  emit("selected", dataset, estimator);
}
</script>

<template>
  <div class="group-selector">
    <div class="title text-base-regular">
      <i class="icon icon-punch-card" />
      {{ title }}
    </div>
    <div class="groups">
      <div v-for="group in groupVM" :key="group.dataset">
        <ProjectDetailViewExperimentsSearchGroupSelectorItem
          :dataset="group.dataset"
          :mlTask="group.mlTasks"
          :estimators="group.estimators"
          @selected="onGroupSelected"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.group-selector {
  display: flex;
  flex-direction: column;
  gap: var(--numbers-16);

  .title {
    .icon {
      color: var(--color-purple-500);
      vertical-align: middle;
    }
  }

  .groups {
    display: flex;
    flex-direction: column;
    padding-left: var(--numbers-8);
    border-left: solid var(--stroke-width-md) var(--border-tertiary);
    gap: var(--numbers-20);
  }
}
</style>
